import { AlertTriangle, Search, EyeOff, MessageSquareWarning } from "lucide-react";

const pains = [
  {
    icon: AlertTriangle,
    title: "Fear of losing irreplaceable pieces.",
    body:
      "A single misplaced couture gown can cost more than a year of your software stack — and your reputation with the client.",
  },
  {
    icon: Search,
    title: "Hours wasted searching.",
    body:
      "Across racks, bins, climate-controlled archives, and the client's third residence — pulls turn into scavenger hunts.",
  },
  {
    icon: EyeOff,
    title: "No clean way to show clients what they own.",
    body:
      "When the client asks 'what do I have in cream silk?', a folder of phone photos isn't an answer.",
  },
  {
    icon: MessageSquareWarning,
    title: "Spreadsheets break the moment a pull goes out.",
    body:
      "Group chats, sticky notes, and shared sheets fall apart the second three assistants edit at once.",
  },
];

export default function Problem() {
  return (
    <section
      data-testid="problem-section"
      aria-labelledby="problem-heading"
      className="py-20 md:py-28"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-5">
            — The problem
          </p>
          <h2
            id="problem-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-balance"
          >
            You weren't trained as a database administrator.{" "}
            <span className="italic text-foreground/55">
              You were trained to dress people.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-border border border-border">
          {pains.map((p, i) => (
            <div
              key={p.title}
              data-testid={`problem-card-${i}`}
              className="bg-background p-8 md:p-10 group hover:bg-bone/60 transition-colors"
            >
              <div className="flex items-start gap-5">
                <div className="w-11 h-11 shrink-0 grid place-items-center border border-oxblood/30 text-oxblood">
                  <p.icon className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-display text-xl md:text-2xl leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-muted-foreground leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
